<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>explore</md-icon>
        </div>
        <h4 class="title">Guides</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newGuide"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Guide</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="guides" @md-selected="viewGuide">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Name">
              {{ item.full_name }}
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger "
                @click.stop="deleteGuide(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewGuide(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            md-label="Show me the way..."
            :md-description="`Add a Guide.`"
          >
            <md-button class="md-primary md-raised" @click="newGuide"
              >Add Guide</md-button
            >
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["guides"],

  data() {
    return {};
  },

  components: {},

  methods: {
    newGuide() {
      this.$emit("addGuide");
    },

    viewGuide(guide) {
      this.$emit("viewGuide", guide);
    },

    deleteGuide(guide) {
      this.$emit("deleteGuide", guide);
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
